// Marques de véhicules pour le champ "Marque du véhicule" d'un Move en mode Ride — ordre
// alphabétique, inclut les marques chinoises (BYD, Chery, Great Wall/Haval, Nio, XPeng...) de
// plus en plus présentes sur le marché européen. Simple liste de suggestions, jamais un choix
// fermé : le champ reste un texte libre, voir components/move/CarMakeField.tsx.
export const CAR_MAKES: string[] = [
  "Abarth", "Acura", "Alfa Romeo", "Alpine", "Aston Martin", "Audi",
  "Baic", "Bentley", "BMW", "BYD",
  "Cadillac", "Changan", "Chery", "Chevrolet", "Chrysler", "Citroën", "Cupra",
  "Dacia", "Daewoo", "Daihatsu", "Dodge", "Dongfeng", "DS Automobiles",
  "Ferrari", "Fiat", "Ford",
  "GAC", "Genesis", "GMC", "Great Wall", "Haval", "Honda", "Hongqi", "Hyundai",
  "Infiniti", "Isuzu",
  "Jaguar", "Jeep",
  "Kia", "Koenigsegg",
  "Lada", "Lamborghini", "Lancia", "Land Rover", "Leapmotor", "Lexus", "Li Auto", "Lincoln", "Lotus", "Lynk & Co",
  "Maserati", "Mazda", "McLaren", "Mercedes-Benz", "MG", "Mini", "Mitsubishi",
  "Nio", "Nissan",
  "Opel", "Ora",
  "Pagani", "Peugeot", "Polestar", "Porsche",
  "Ram", "Renault", "Rolls-Royce", "Rover",
  "Saab", "SAIC", "Seat", "Seres", "Škoda", "Skywell", "Smart", "SsangYong", "Subaru", "Suzuki",
  "Tesla", "Toyota",
  "Vauxhall", "VinFast", "Volkswagen", "Volvo",
  "Wuling",
  "XPeng",
  "Zeekr",
];
